import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { InputControl } from './component-interfaces';
import { ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'base-control-do-not-use',
  template: ''
})
export class BaseControl implements OnInit, InputControl, ControlValueAccessor {
    @Input() public enabled: boolean = true;
    @Input() public disabled: boolean = false;
    @Input() public show: boolean = true;
    @Input() public classes: string = '';
    @Input() public value: any;
    @Input() public label: string = '';
    @Input() public help: string = '';
    @Input() public info: string = '';
    @Input() public helpUrl: string = '';
    @Input() public validate: boolean = false;
    @Input() public errorMessage: string = '';
    @Input() public successMessage: string = '';
    @Input() public required: boolean = false;
    @Input() public pattern: RegExp = null;

    @Output() onUpdate = new EventEmitter();

    onChange;

    public id: string = '';
    valueChangedDelay: number = 0;

    constructor() {
      this.id = new Date().getTime() + '-' + Math.random().toString(36).substring(5);
    }

    setDisabledState(isDisabled: boolean): void {
      this.disabled = isDisabled;
    }

    updateValue() {
      if (this.onChange) setTimeout(() => {
        this.onUpdate.emit(this.value);
        this.onChange(this.value);
      }, this.valueChangedDelay);
    }

    writeValue(value) {
      this.value = value;

      this.onWriteValue(value);
    }

    onWriteValue(value) {

    }

    registerOnChange(fn) {
      this.onChange = fn;
    }

    registerOnTouched(fn) {  }

    ngOnInit() {}
}
